import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Applayout from "../../../utils/layout/Applayout";
import styles from "./style/Createprofiletutor.module.css";
import { adminAPI, clientAPI } from "../../../utils/axiosInstance";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { updateTutorId } from "../../../redux/actions/authActions";
import RedirectComponent from "../../../utils/commoncomponent/RedirectComponent";
import { fetchLocalitiesRequest } from "../../../redux/actions/localityActions";
import { isIndianResidentialAddress } from "../../../utils/studentAddressHelpers";
import { getMajorCountrySelectOptions } from "../../../utils/majorCountries";
import { TiTick } from "react-icons/ti";
import "react-toastify/dist/ReactToastify.css";
import TutorTeachingPreferences from "../../../utils/components/TutorTeachingPreferences";
import TutorAvailabilityQuickApply from "../../../utils/components/TutorAvailabilityQuickApply";
import { mergeAvailabilitySlots } from "../../../utils/tutorAvailabilityUtils";
import {
  buildTutorProfileSubmitPayload,
  filterCategoriesForSelection,
  syncCategoryIdsForTeachingSelection,
} from "../../../utils/tutorTeachingUtils";
import TermsLink from "../Terms/TermsLink";

const initialFormData = {
  user: {
    userId: "",
    gender: "male",
    contactDetails: {
      address: {
        addressLine1: "",
        locality: "",
        pincode: "",
        city: "",
        state: "",
        country: "",
        indianResident: true,
      },
    },
    // active: true,
    // status: "NEW",
  },
  individual: true,
  institution: {},
  // languages: [{ language: "", proficiency: "" }],
  languages: {},
  educationalBackground: "",
  yearofcompletion: "",
  degreeStatus: "",
  yearOfExp: 0,
  tuitionMode: "ONLINE",
  board: "",
  gradeCategory: "PRIMARY",
  studyGroupType: "ONE_ON_ONE",
  feePerHour: 0,
  upiId: "",
  accountHolderName: "",
  experience: "",
  subjectCategoryList: [],
  timeslots: [],
};

const DOCUMENT_TYPES = [
  { label: "Photo ID Card", value: "kyc1" },
  { label: "Educational Certificates", value: "cert1" },
  { label: "Experience Certificates", value: "cert2" },
  { label: "KYC Document", value: "kyc2" },
  { label: "Other Certificates", value: "cert3" },
];

const Createprofiletutor = () => {
  const [formData, setFormData] = useState(initialFormData);
  const [image, setImage] = useState();
  const [subjectData, setSubjectData] = useState([]);
  const [selectedBoards, setSelectedBoards] = useState([]);
  const [selectedGrades, setSelectedGrades] = useState([]);
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);
  const [studyGroupTypes, setStudyGroupTypes] = useState({
    oneOnOne: true,
    group: false,
  });
  const [teachingErrors, setTeachingErrors] = useState({});
  const userId = useSelector((state) => state.auth.userId);
  const tutorId = useSelector((state) => state.auth.tutorId);
  const userdata = useSelector((state) => state.userdata?.data);
  const addedByName =
    userdata?.userName ||
    formData?.user?.userName ||
    userId ||
    "Tutor";

  const handleSubjectCatalogUpdated = (categories = [], options = {}) => {
    if (options.replace && Array.isArray(categories)) {
      setSubjectData(categories);
      return;
    }
    setSubjectData((prev) => {
      const map = new Map(prev.map((item) => [item.categoryId, item]));
      categories.forEach((item) => {
        if (item?.categoryId != null) {
          map.set(item.categoryId, item);
        }
      });
      return Array.from(map.values());
    });
  };
  const navigate = useNavigate();
  const [errors, setError] = useState({});
  const [yearOfExperrors, setYearOfExpeError] = useState("");
  const [pincodeerrors, setPincodeErrors] = useState("");
  const [localityerror, setLocalityerror] = useState("");
  const [feeError, setFeeError] = useState("");
  const pincodeRef = useRef(null);
  const subjectRef = useRef(null);
  const dispatch = useDispatch();
  const [files, setFiles] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);
  const [daySelections, setDaySelections] = useState([
    { id: 0, day: "", timeSlot: "" },
  ]);
  const [inputFields, setInputFields] = useState([
    { id: 1, docType: "", file: null },
    { id: 2, docType: "", file: null },
  ]);
  // const [imageUploaded, setImageUploaded] = useState(false);
  // const [documentsUploaded, setDocumentsUploaded] = useState(false);

  const localityData = useSelector((state) => state.locality.localities);
  const localityLoading = useSelector((state) => state.locality.loading);
  const localityDistrict = useSelector((state) => state.locality.district);
  const localityStateName = useSelector((state) => state.locality.state);

  const countrySelectOptions = useMemo(
    () => getMajorCountrySelectOptions(formData.user.contactDetails.address.country),
    [formData.user.contactDetails.address.country],
  );
  const [languagesData, setLanguagesData] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState({
    language: "",
    proficiency: "",
  });
  // const [selectedLanguageList, setSelectedLanguageList] = useState([]);
  const [institutions, setInstitutions] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [proficiencyOptions, setProficiencyOptions] = useState([]);
  const [selectedProficiency, setSelectedProficiency] = useState("");
  const [selectedLanguageList, setSelectedLanguageList] = useState([]);
  const [instituteLimitError, setInstituteLimitError] = useState(false);
  const InstituteTutorRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [visibleSections, setVisibleSections] = useState({
    save: true,
    submit: true,
    cancel: true,
  });

  const handleToggleVisibility = (section) => {
    setVisibleSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  useEffect(() => {
    const checkStatus = async () => {
      try {
        const response = await adminAPI.get(`/admin/user/${userId}`);
        const status = response.data.status;
        if (
          status === "PENDING_SUBSCRIPTION" ||
          status === "SUBCRIPTION_ACTIVE" ||
          status === "ACTIVE"
        ) {
          navigate("/homepage");
          console.log("status", status);
        }
      } catch (error) {
        console.error("Error fetching user using get user api:", error);
      }
    };

    checkStatus();
  }, [userId]);

  useEffect(() => {
    // API call to get languages
    adminAPI
      .get("/admin/languages")
      .then((response) => {
        setLanguagesData(response.data);
      })
      .catch((error) => console.error("Error fetching languages", error));
  }, []);

  useEffect(() => {
    // API call to get the list of active institutions
    adminAPI
      .get(`/admin/getAllActiveInstitution?activerequired=true`)
      .then((response) => {
        setInstitutions(response.data);
      })
      .catch((error) => console.error("Error fetching institutions:", error));
  }, []);

  useEffect(() => {
    if (userId) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        user: { ...prevFormData.user, userId: userId },
      }));
    }
  }, [userId]);

  useEffect(() => {
    if (!isIndianResidentialAddress(formData.user.contactDetails.address)) {
      return;
    }
    if (!localityDistrict && !localityStateName) {
      return;
    }
    setFormData((prev) => {
      const address = prev.user.contactDetails.address;
      const nextCity = localityDistrict || address.city;
      const nextState = localityStateName || address.state;
      if (address.city === nextCity && address.state === nextState) {
        return prev;
      }
      return {
        ...prev,
        user: {
          ...prev.user,
          contactDetails: {
            ...prev.user.contactDetails,
            address: {
              ...address,
              city: nextCity,
              state: nextState,
            },
          },
        },
      };
    });
  }, [localityDistrict, localityStateName]);

  useEffect(() => {
    adminAPI
      .get("/admin/subjectCategory?activeRequired=true")
      .then((response) => {
        setSubjectData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching subjectcategory data", error);
      });
  }, []);

  useEffect(() => {
    if (
      !subjectData.length ||
      !selectedBoards.length ||
      !selectedGrades.length
    ) {
      return;
    }

    setSelectedCategoryIds((prev) =>
      syncCategoryIdsForTeachingSelection(
        subjectData,
        selectedBoards,
        selectedGrades,
        prev,
      ),
    );
  }, [selectedBoards, selectedGrades, subjectData]);

  const validateTeachingPreferences = () => {
    const nextErrors = {};
    if (!selectedBoards.length) {
      nextErrors.boards = "Select at least one board.";
    }
    if (!selectedGrades.length) {
      nextErrors.grades = "Select at least one grade.";
    }
    if (!selectedCategoryIds.length) {
      nextErrors.subjects = "Select at least one subject.";
    }
    if (!studyGroupTypes.oneOnOne && !studyGroupTypes.group) {
      nextErrors.studyGroupType = "Select one-on-one, group, or both.";
    }
    setTeachingErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleChange = (e, index) => {
    const { name, value, type, checked } = e.target;

    if (name === "termsCheckbox") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        infoCorrect: checked,
      }));
      return;
    }

    if (name === "yearOfExp") {
      const numericValue = parseInt(value, 10);
      if (
        value === "" ||
        (numericValue > 0 && numericValue < 99 && /^[0-9]*$/.test(value))
      ) {
        setYearOfExpeError(""); // Clear error if valid
      } else {
        setYearOfExpeError("Please enter a valid number up to 2 digits.");
      }
    }

    const booleanValue = value === "true";

    if (name === "individual") {
      // Self-service tutors must remain freelancers (not associated with an institution).
      setFormData((prevData) => ({
        ...prevData,
        individual: true,
        institution: {},
      }));
      return;
    }

    // handling other inputs
    if (type === "checkbox" && name !== "termsCheckbox") {
      handleCheckboxChange(e);
      return;
    }
    setFormData((prevFormData) => {
      let updatedFormData = { ...prevFormData };
      switch (name) {
        case "pincode":
          if (value.length <= 6 && /^\d*$/.test(value)) {
            updatedFormData.user.contactDetails.address[name] = value;
            if (value.length !== 6) {
              updatedFormData.user.contactDetails.address.locality = "";
              updatedFormData.user.contactDetails.address.city = "";
              updatedFormData.user.contactDetails.address.state = "";
            } else if (
              isIndianResidentialAddress(updatedFormData.user.contactDetails.address)
            ) {
              dispatch(fetchLocalitiesRequest(value));
            }
          }
          break;
        case "locality":
        case "addressLine1":
        case "city":
        case "state":
        case "country":
          updatedFormData.user.contactDetails.address[name] = value;
          break;
        case "indianResident": {
          const indian = value === "true";
          updatedFormData.user.contactDetails.address.indianResident = indian;
          if (indian) {
            updatedFormData.user.contactDetails.address.country = "";
          } else {
            updatedFormData.user.contactDetails.address.pincode = "";
            updatedFormData.user.contactDetails.address.locality = "";
            updatedFormData.user.contactDetails.address.city = "";
            updatedFormData.user.contactDetails.address.state = "";
          }
          break;
        }
        case "gender":
        case "userId":
          updatedFormData.user[name] = value;
          break;
        case "board":
          updatedFormData = {
            ...updatedFormData,
            board: value,
            subjectCategoryList: [],
          };
          break;
        case "subjectCategoryList":
          updatedFormData.subjectCategoryList = value.map((id) => ({
            categoryId: id,
          }));
          break;
        case "experience":
          updatedFormData[name] = value;
          break;
        case "feePerHour":
          updatedFormData[name] = value;
          const numericFee = parseInt(value.replace(/[^0-9.]/g, ""));
          if (isNaN(numericFee) || numericFee < 100 || numericFee > 10000) {
            setFeeError("fee must be between 100 and 10,000");
          } else {
            setFeeError("");
          }
          break;
        default:
          updatedFormData[name] = value;
          break;
      }
      return updatedFormData;
    });
  };

  const handleInstitutionChange = (e) => {
    const selectedInstitutionId = e.target.value;

    // Make the API call to fetch the institute details if needed
    const selectedInstitution = institutions.find(
      (inst) => inst.institutionId === parseInt(selectedInstitutionId),
    );

    setFormData((prevFormData) => ({
      ...prevFormData,
      // institution: selectedInstitution || {},
      institution: selectedInstitution
        ? {
            institutionId: selectedInstitution.institutionId,
            name: selectedInstitution.name,
          }
        : {},
    }));
  };

  const uniqueLanguages = Array.from(
    new Set(languagesData.map((lang) => lang.language)),
  );

  // Handle language selection
  const handleSelectLanguage = (e) => {
    const selectedLang = e.target.value;
    setSelectedLanguage(selectedLang);

    // Get the proficiencies for the selected language
    const proficiencyForLang = languagesData
      .filter((lang) => lang.language === selectedLang)
      .map((lang) => lang.proficiency);

    setProficiencyOptions(proficiencyForLang);
    setSelectedProficiency(""); // Reset proficiency when new language is selected
  };

  // Handle proficiency selection
  const handleSelectProficiency = (e) => {
    setSelectedProficiency(e.target.value);
  };

  // Handle add language
  const handleAddLanguage = (e) => {
    e.preventDefault();

    if (selectedLanguage && selectedProficiency) {
      const isDuplicate = selectedLanguageList.find(
        (lang) =>
          lang.language.toLowerCase() === selectedLanguage.toLowerCase(),
      );

      if (isDuplicate) {
        toast.error("You cannot select the same language twice!");
      } else {
        const newLanguage = {
          language: selectedLanguage,
          proficiency: selectedProficiency,
        };

        setSelectedLanguageList([...selectedLanguageList, newLanguage]);

        setFormData((prevFormData) => ({
          ...prevFormData,
          languages: {
            ...prevFormData.languages,
            [selectedLanguage]: selectedProficiency,
          },
        }));
      }
    }
  };

  // Handle remove language
  const handleRemoveLanguage = (language) => {
    const updatedList = selectedLanguageList.filter(
      (lang) => lang.language !== language,
    );
    setSelectedLanguageList(updatedList);

    setFormData((prevFormData) => {
      const updatedLanguages = { ...prevFormData.languages };
      delete updatedLanguages[language];
      return { ...prevFormData, languages: updatedLanguages };
    });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    const categoryId = parseInt(name, 10);
    if (isNaN(categoryId)) {
      console.warn(`Invalid categoryId: ${name}`);
      return;
    }
    console.log(`CategoryId: ${categoryId}, Checked: ${checked}`);
    setFormData((prevState) => {
      const updatedCategories = checked
        ? [...prevState.subjectCategoryList, { categoryId }]
        : prevState.subjectCategoryList.filter(
            (category) => category.categoryId !== categoryId,
          );
      return {
        ...prevState,
        subjectCategoryList: updatedCategories,
      };
    });
  };

  const addLanguageInput = () => {
    const lastLanguage = formData.languages[formData.languages.length - 1];

    if (!lastLanguage.language.trim()) {
      toast.error("Please enter a language before adding another.");
      return;
    }
    if (!lastLanguage.proficiency) {
      toast.error("Please select proficiency before adding another.");
      return;
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      languages: [...prevFormData.languages, { language: "", proficiency: "" }],
    }));
  };

  const handleLanguageRemove = (index) => {
    const updatedLanguages = formData.languages.filter((_, i) => i !== index);
    setFormData((prevFormData) => ({
      ...prevFormData,
      languages: updatedLanguages,
    }));
  };

  const Validation = () => {
    let isValid = true;
    const updatedErrors = {};

    const addr = formData.user.contactDetails.address;
    if (isIndianResidentialAddress(addr)) {
      if (addr.pincode.length !== 6 || isNaN(addr.pincode)) {
        isValid = false;
        updatedErrors.pinCodenum = "Pincode must be 6 digits";
        toast.error("Pincode should be 6 digits long");
        pincodeRef.current?.focus();
      }
      if (addr.locality.trim().length < 2) {
        isValid = false;
        updatedErrors.localityerr = "Locality should have at least 2 characters";
        setLocalityerror("Locality should have at least 2 characters");
        toast.error("Locality should have at least 2 characters");
      } else if (/^[\s]/.test(addr.locality)) {
        isValid = false;
        updatedErrors.localityerr = "Locality should not start with a space";
        setLocalityerror("Locality should not start with a space");
        toast.error("Locality should not start with a space");
      }
      if (!addr.city || addr.city.trim().length < 2) {
        isValid = false;
        updatedErrors.cityerr = "City is required. Enter a valid pincode to auto-fill.";
        toast.error("City is required. Enter a valid pincode to auto-fill.");
      }
      if (!addr.state || addr.state.trim().length < 2) {
        isValid = false;
        updatedErrors.stateerr = "State is required. Enter a valid pincode to auto-fill.";
        toast.error("State is required. Enter a valid pincode to auto-fill.");
      }
      if (addr.addressLine1.trim().length < 2) {
        isValid = false;
        updatedErrors.addressError = "Address should have at least 2 characters";
        toast.error("Address should have at least 2 characters");
      } else if (/^[\s]/.test(addr.addressLine1)) {
        isValid = false;
        updatedErrors.addressError = "Address should not start with a space";
      }
    } else {
      if (addr.country.trim().length < 2) {
        isValid = false;
        updatedErrors.countryerr = "Country is required";
        toast.error("Country is required");
      } else if (/^[\s]/.test(addr.country)) {
        isValid = false;
        updatedErrors.countryerr = "Country should not start with a space";
        toast.error("Country should not start with a space");
      }
      if (addr.addressLine1.trim().length < 2) {
        isValid = false;
        updatedErrors.addressError = "Enter your full address (at least 2 characters)";
        toast.error("Enter your full address");
      } else if (/^[\s]/.test(addr.addressLine1)) {
        isValid = false;
        updatedErrors.addressError = "Address should not start with a space";
      }
    }

    if (!validateTeachingPreferences()) {
      isValid = false;
      toast.error("Please complete board, grade, subject, and session type.");
    }

    // Years of Experience validation
    const yearOfExp = parseFloat(formData.yearOfExp);
    if (isNaN(yearOfExp) || yearOfExp <= 0 || yearOfExp >= 99) {
      isValid = false;
      updatedErrors.yearOfExp =
        "Years of experience must be a number up to 2 digits long";
      toast.error("Years of experience must be a number up to 2 digits long");
      setYearOfExpeError(
        "Years of experience must be a number up to 2 digits long",
      );
    }

    // Fee per month validation
    const maxFee = parseFloat(formData.feePerHour);
    if (isNaN(maxFee) || maxFee < 100 || maxFee > 10000) {
      isValid = false;
      // updatedErrors.feePerHourerror("Fee must be between 100 and 10,000");
      setFeeError("fee must be between 100 and 10,000");
      toast.error("fee must be between 100 and 10,000");
    }

    const upiId = (formData.upiId || "").trim();
    if (!upiId || !upiId.includes("@")) {
      isValid = false;
      updatedErrors.upiId = "Enter a valid UPI ID (example: name@bank)";
      toast.error("Enter a valid UPI ID (example: name@bank)");
    }

    const accountHolderName = (formData.accountHolderName || "").trim();
    if (!accountHolderName || accountHolderName.length < 2) {
      isValid = false;
      updatedErrors.accountHolderName = "Enter the account holder name";
      toast.error("Enter the account holder name");
    }

    // textareavalidation
    if (
      formData.experience.trim().length < 20 ||
      formData.experience.trim().length > 120
    ) {
      isValid = false;
      setError("experience must between 20 and 120 words");
      toast.error("experience must between 20 and 120 words");
    }

    //language
    if (selectedLanguageList.length === 0) {
      isValid = false;
      updatedErrors.language = "Please select at least one language";
      toast.error("Please select at least one language");
    }

    //terms&conditions
    const termsCheckbox = document.getElementById("termsCheckbox");
    if (!termsCheckbox.checked) {
      isValid = false;
      toast.error("Please agree to the terms and conditions");
    }
    if (!image) {
      isValid = false;
      toast.error("Image is requried");
      setError("image is required");
    }
    if (files.length === 0) {
      isValid = false;
      toast.error("Please select a document to upload");
      return;
    }
    const mandatoryDocuments = ["kyc1", "cert1"];
    const uploadedMandatoryDocTypes = inputFields
      .filter(
        (field) =>
          mandatoryDocuments.includes(field.docType) &&
          files.some((file) => file.id === field.id && file.file),
      )
      .map((field) => field.docType);

    const missingDocuments = mandatoryDocuments.filter(
      (requiredType) => !uploadedMandatoryDocTypes.includes(requiredType),
    );
    if (missingDocuments.length > 0) {
      isValid = false;
      toast.error("Please upload Photo ID Card and Educational Certificates.");
    }
    setError(updatedErrors);
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    const selectedFileNames = files
      .map((file) => file?.file?.name?.trim().toLowerCase())
      .filter(Boolean);
    const hasDuplicateFileNames =
      new Set(selectedFileNames).size !== selectedFileNames.length;
    if (hasDuplicateFileNames) {
      toast.error("File names cannot be the same. Please rename and re-upload.");
      setIsSubmitting(false);
      return;
    }

    // Check for mandatory document types that also have selected files
    const mandatoryDocuments = ["kyc1", "cert1"];
    const uploadedMandatoryDocTypes = inputFields
      .filter(
        (field) =>
          mandatoryDocuments.includes(field.docType) &&
          files.some((file) => file.id === field.id && file.file),
      )
      .map((field) => field.docType);
    const missingDocuments = mandatoryDocuments.filter(
      (requiredType) => !uploadedMandatoryDocTypes.includes(requiredType),
    );
    if (missingDocuments.length > 0) {
      toast.error("Please upload Photo ID Card and Educational Certificates.");
      setIsSubmitting(false);
      return;
    }

    const isValid = Validation();
    if (!isValid) {
      setIsSubmitting(false);
      return;
    }

    if (!image) {
      toast.error("Please select an image to upload");
      setIsSubmitting(false);
      return;
    }

    // Check image type and size
    const allowedImageTypes = ["image/png", "image/jpeg", "image/gif"];
    const maxSize = 2 * 1024 * 1024; // 2MB in bytes

    if (!allowedImageTypes.includes(image.type)) {
      toast.error("Invalid image format. Only PNG, JPEG, and GIF are allowed.");
      setIsSubmitting(false);
      return;
    }

    if (image.size > maxSize) {
      toast.error("Image size exceeds 2MB. Please select a smaller image.");
      setIsSubmitting(false);
      return;
    }

    // Document validation
    const validFilesTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "image/png",
      "image/jpeg",
      "image/jpg",
    ];

    const maxFileSize = 10 * 1024 * 1024;

    const invalidFiles = files.filter(
      (file) =>
        !validFilesTypes.includes(file.file.type) ||
        file.file.size > maxFileSize,
    );

    if (invalidFiles.length > 0) {
      invalidFiles.forEach((file) => {
        if (!validFilesTypes.includes(file.file.type)) {
          toast.error(
            `File "${file.file.name}" is not a valid file type. Please use PDF, Word, PNG, or JPEG.`,
          );
        }
        if (file.file.size > maxFileSize) {
          toast.error(
            `File "${file.file.name}" exceeds 10MB. Please select a smaller file.`,
          );
        }
      });
      setIsSubmitting(false);
      return;
    }

    const validFiles = files.filter(
      (file) =>
        validFilesTypes.includes(file.file.type) &&
        file.file.size <= maxFileSize,
    );
    if (validFiles.length === 0) {
      toast.error(
        "Please select valid documents (PDF, Word, PNG, or JPEG) with size <= 10MB",
      );
      setIsSubmitting(false);
      return;
    }

    // validate uploading documents
    validateDocuments(validFiles);
  };

  const validateDocuments = (validFiles) => {
    let validatedCount = 0;
    let allValid = true;

    validFiles.forEach((file) => {
      const formData = new FormData();
      formData.append("file", file.file);
      formData.append("userId", userId);
      adminAPI
        .put(`/validate-document`, formData, {
          headers: {
            "Content-Type": "multipart/for-data",
          },
        })
        .then((response) => {
          validatedCount++;
          if (response.data[0].fileValid === false) {
            allValid = false;
            toast.error(
              `Document "${response.data[0].docName}" is invalid: ${response.data[0].reason}`,
            );
          }

          if (validatedCount === validFiles.length) {
            if (allValid) {
              uploadDocuments(0, validFiles);
            } else {
              toast.error(
                "documents failed validation. Please check and try again.",
              );
              setIsSubmitting(false);
            }
          }
        })
        .catch((error) => {
          console.error("Error validating document:", error);
          toast.error(
            `Error validating document "${file.file.name}". Please try again.`,
          );
          validatedCount++;

          // Check if all files have been processed
          if (validatedCount === validFiles.length) {
            toast.error("Document validation failed. Please try again.");
            setIsSubmitting(false);
          }
        });
    });
  };

  const uploadDocuments = (index, validFiles) => {
    if (index >= validFiles.length) {
      // All documents uploaded, proceed with profile picture upload
      uploadProfilePicture();
      return;
    }

    const file = validFiles[index].file;
    const selectedDocType =
      inputFields.find((field) => field.id === validFiles[index].id)?.docType ||
      "KYC";
    const docType = selectedDocType.startsWith("kyc") ? "KYC" : "Certification";
    console.log({ selectedDocType, docType });
    const docFormData = new FormData();
    docFormData.append("file", file);

    adminAPI
      .post(
        `/upload-document?documentType=${docType}&userId=${userId}`,
        docFormData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      )
      .then((response) => {
        console.log(`Document ${index + 1} upload successful`, response.data);
        toast.success(`Document ${index + 1} uploaded successfully`);
        uploadDocuments(index + 1, validFiles);
      })
      .catch((error) => {
        console.error(`Error uploading document ${index + 1}:`, error);
        const errorMessage =
          error.response?.data?.message ||
          `Document ${index + 1} upload failed, try again`;
        toast.error(errorMessage);
        setIsSubmitting(false);
        // cancelAPI(new Event("cancel"));
        handleCancel(new Event("cancel"));
      });
  };

  const uploadProfilePicture = () => {
    const imageFormData = new FormData();
    imageFormData.append("file", image);
    imageFormData.append("userId", userId);
    imageFormData.append("isProfilePic", true);

    adminAPI
      .post("/upload-image", imageFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((imageResponse) => {
        console.log("Image upload successful", imageResponse.data);
        toast.success("Image upload successful");
        // Now submit the profile data
        submitProfileData();
      })
      .catch((error) => {
        console.error("Error uploading image:", error);
        const errorMessage =
          error.response?.data?.message || "Image upload failed, try again";
        toast.error(errorMessage);
        setIsSubmitting(false);
        // cancelAPI(new Event("cancel"));
        handleCancel(new Event("cancel"));
      });
  };

  const submitProfileData = () => {
    // Transform languages
    // const transformedLanguages = formData.languages.reduce((acc, langObj) => {
    //   if (langObj.language && langObj.proficiency) {
    //     acc[langObj.language] = langObj.proficiency;
    //   }
    //   return acc;
    // }, {});

    // Create final form data
    const transformedFormData = buildTutorProfileSubmitPayload({
      formData: {
        ...formData,
        individual: true,
        institution: {},
      },
      selectedCategoryIds,
      selectedBoards,
      selectedGrades,
      subjectData,
      studyGroupTypes,
    });

    // Submit profile data
    console.log("request data", transformedFormData);
    clientAPI
      .post("/tutor/profile", transformedFormData)
      .then((response) => {
        console.log("Profile created successfully:", response.data);
        const tutorId = response.data.data.tutorId;
        const status = response.data.data.user.status;
        toast.success("Profile created successfully");
        setTimeout(() => {
          if (status === "PENDING_SUBSCRIPTION") {
            navigate("/subscription");
          } else {
            navigate("/homepage");
          }
        }, 1000);
        dispatch(updateTutorId(tutorId));
      })
      .catch((error) => {
        console.error("Error creating profile:", error);
        // if (error.response?.data?.errorCode === 1038) {
        if (
          error.response?.data?.message?.includes(
            "Institute has utilised maximum registration limit",
          )
        ) {
          setInstituteLimitError(true);
          setTimeout(() => {
            InstituteTutorRef.current?.scrollIntoView({ behavior: "smooth" });
          }, 100);
        }
        const errorMessage =
          error.response?.data?.message ||
          error.response?.data?.detail ||
          "Profile creation failed, try again";
        toast.error(errorMessage);
        setIsSubmitting(false);
        adminAPI
          .delete(`/delete-document/${userId}`)
          .then((deleteResponse) => {
            console.log("Document deleted successfully:", deleteResponse.data);
          })
          .catch((deleteError) => {
            console.error("Error deleting document:", deleteError);
            const deleteErrorMessage =
              deleteError.response?.data?.message || "Document deletion failed";
            toast.error(deleteErrorMessage);
          });
      });
  };

  const cancelAPI = (e) => {
    e.preventDefault();
    clientAPI
      .put(`/tutor/cancel?userId=${userId}`)
      .then((response) => {
        console.log("profile creation cancelled", response.data);
        toast.success("profile creation cancelled");
        // navigate("/homepage");
      })
      .catch((error) => {
        console.error("Error creating profile:", error);
        const errorMessage =
          error?.response?.data?.message || "Cancel Profile Failed, Try Again";
        toast.error(errorMessage);
      });
  };

  // const handleCancel = (e) => {
  //   e.preventDefault();
  //   clientAPI
  //     .put(`/tutor/cancel?userId=${userId}`)
  //     .then((response) => {
  //       console.log("profile creation cancelled", response.data);
  //       toast.success("profile creation cancelled");
  //       navigate("/homepage");
  //     })
  //     .catch((error) => {
  //       console.error("Error creating profile:", error);
  //       const errorMessage =
  //         error.response.data.message || "Cancel Profile Failed, Try Again";
  //       toast.error(errorMessage);
  //     });
  // };

  const handleCancel = (e) => {
    e.preventDefault();

    adminAPI
      .delete(`/delete-document/${userId}`)
      .then((deleteResponse) => {
        console.log("Document deleted successfully:", deleteResponse.data);

        return clientAPI.put(`/tutor/cancel?userId=${userId}`);
      })
      .then((response) => {
        console.log("Profile creation cancelled", response.data);
        toast.error("Profile creation cancelled");
        navigate("/homepage");
      })
      .catch((error) => {
        console.error("Error in process:", error);
        const errorMessage =
          error.response?.data?.message || "Operation failed, try again";
        toast.error(errorMessage);
      });
  };

  // timeslot fetch
  useEffect(() => {
    adminAPI
      .get("/admin/timeslot?activeRequired=true")
      .then((response) => {
        setTimeSlots(response.data || []);
        // console.log("timeslots :", response.data);
      })
      .catch((error) => {
        console.error("Error fetching timeslots", error);
      });
  }, []);

  const handleDayChange = (e, id) => {
    const { value } = e.target;
    setDaySelections((prevSelections) =>
      prevSelections.map((selection) =>
        selection.id === id
          ? { ...selection, day: value, timeSlot: "" }
          : selection,
      ),
    );
  };

  const handleTimeSlotChange = (e, id) => {
    const { value } = e.target;

    const isDuplicate = daySelections.some(
      (selection) => selection.id !== id && selection.timeSlot === value,
    );

    if (isDuplicate) {
      toast.error(
        "Timeslot has been selected. please choose a different timtslot",
      );
      return;
    }

    setDaySelections((prevSelections) =>
      prevSelections.map((selection) =>
        selection.id === id ? { ...selection, timeSlot: value } : selection,
      ),
    );

    // Update formData with selected time slots
    const updatedSelections = daySelections.map((selection) =>
      selection.id === id ? { ...selection, timeSlot: value } : selection,
    );
    const selectedTimeSlotIds = updatedSelections
      .filter((selection) => selection.timeSlot)
      .map((selection) => ({ timeSlotId: parseInt(selection.timeSlot) }));
    setFormData((prevFormData) => ({
      ...prevFormData,
      timeslots: selectedTimeSlotIds,
    }));
  };

  const handleAddMore = () => {
    const lastTimeslot = daySelections[daySelections.length - 1];
    if (!lastTimeslot.day.trim()) {
      toast.error("Please select a day before adding another");
      return;
    }
    if (!lastTimeslot.timeSlot) {
      toast.error("Please select a timeslot before adding another");
    }
    const newId =
      Math.max(...daySelections.map((selection) => selection.id)) + 1;
    setDaySelections([...daySelections, { id: newId, day: "", timeSlot: "" }]);
  };

  const handleRemove = (id) => {
    setDaySelections((prevSelections) =>
      prevSelections.filter((selection) => selection.id !== id),
    );

    // Update formData with the remaining time slots
    const updatedSelections = daySelections.filter(
      (selection) => selection.id !== id,
    );
    const selectedTimeSlotIds = updatedSelections
      .filter((selection) => selection.timeSlot)
      .map((selection) => ({ timeSlotId: parseInt(selection.timeSlot) }));
    setFormData((prevFormData) => ({
      ...prevFormData,
      timeslots: selectedTimeSlotIds,
    }));
  };

  const handleClearAllTimeSlots = () => {
    setDaySelections([{ id: 0, day: "", timeSlot: "" }]);
    setFormData((prevFormData) => ({
      ...prevFormData,
      timeslots: [],
    }));
  };

  const handleQuickApplyAvailability = (builtSlots) => {
    const existingSelections = daySelections
      .filter((selection) => selection.day && selection.timeSlot)
      .map((selection) => ({
        daysOfWeek: selection.day,
        timeSlotId: parseInt(selection.timeSlot, 10),
      }));
    const merged = mergeAvailabilitySlots(existingSelections, builtSlots);
    const newSelections = merged.map((slot, index) => ({
      id: index,
      day: slot.daysOfWeek,
      timeSlot: String(slot.timeSlotId),
    }));

    setDaySelections(
      newSelections.length
        ? newSelections
        : [{ id: 0, day: "", timeSlot: "" }],
    );
    setFormData((prevFormData) => ({
      ...prevFormData,
      timeslots: merged.map((slot) => ({
        timeSlotId: parseInt(slot.timeSlotId, 10),
      })),
    }));
  };

  // image upload api
  const handleImage = (e) => {
    setImage(e.target.files[0]);
    console.log(e.target.files);
  };

  // document upload
  const handleFileChange = (e, id) => {
    const selectedFile = e.target.files[0];
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      const index = newFiles.findIndex((file) => file.id === id);
      if (index !== -1) {
        newFiles[index] = { id, file: selectedFile };
      } else {
        newFiles.push({ id, file: selectedFile });
      }
      return newFiles;
    });
  };

  const handleDocTypeChange = (e, id) => {
    const { value } = e.target;
    setInputFields((prevFields) =>
      prevFields.map((field) =>
        field.id === id ? { ...field, docType: value } : field,
      ),
    );
  };

  const addFileInput = () => {
    if (inputFields.length < 5) {
      const newId = Math.max(...inputFields.map((field) => field.id), 0) + 1;
      setInputFields((prevFields) => [
        ...prevFields,
        { id: newId, docType: "" },
      ]);
    } else {
      toast.error("You can upload a maximum of 5 documents");
    }
  };

  const removeFileInput = (idToRemove) => {
    setInputFields((prevFields) =>
      prevFields.filter((field) => field.id !== idToRemove),
    );
    setFiles((prevFiles) => prevFiles.filter((file) => file.id !== idToRemove));
  };

  // Get today's date in YYYY-MM-DD format
  const today = new Date().toISOString().split("T")[0];

  // Determine the max date based on the degree status
  // const maxDate = formData.degreeStatus === "completed" ? today : "";
  return (
    <Applayout>
      <RedirectComponent componentRole="tutor" />

      <div className={styles.createProfile}>
        <form onSubmit={handleSubmit}>
          <div>
            <label className={styles.formLbel}>
              Where do you live? <span style={{ color: "red" }}>*</span>
            </label>
            <br />
            <label id={styles.radioLabels}>
              <input
                type="radio"
                name="indianResident"
                value="true"
                checked={isIndianResidentialAddress(formData.user.contactDetails.address)}
                onChange={handleChange}
              />{" "}
              India
            </label>
            <label id={styles.radioLabels}>
              <input
                type="radio"
                name="indianResident"
                value="false"
                checked={!isIndianResidentialAddress(formData.user.contactDetails.address)}
                onChange={handleChange}
              />{" "}
              Outside India
            </label>
          </div>
          {isIndianResidentialAddress(formData.user.contactDetails.address) ? (
            <>
              <div>
                <label htmlFor="address" className={styles.formLbel}>
                  Street address <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <input
                  className={styles.pincodeInput}
                  type="text"
                  name="addressLine1"
                  required
                  onChange={handleChange}
                  value={formData.user.contactDetails.address.addressLine1}
                  placeholder="Street, area, landmark"
                />
                {errors.addressError && (
                  <div style={{ color: "red", marginTop: "5px" }}>{errors.addressError}</div>
                )}
              </div>
              <div>
                <label htmlFor="pincode" className={styles.formLbel}>
                  Pincode <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <input
                  className={styles.pincodeInput}
                  type="text"
                  name="pincode"
                  maxLength={6}
                  required
                  onChange={handleChange}
                  value={formData.user.contactDetails.address.pincode}
                  placeholder="6-digit pincode"
                  ref={pincodeRef}
                />
                {errors.pinCodenum && <div style={{ color: "red" }}>{errors.pinCodenum}</div>}
                {pincodeerrors && <div style={{ color: "red" }}>{pincodeerrors}</div>}
              </div>
              <div>
                <label htmlFor="locality" className={styles.formLbel}>
                  Locality <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                {localityLoading ? (
                  <div style={{ fontSize: "18px" }}>Loading localities...</div>
                ) : localityData.length === 0 ? (
                  <div style={{ fontSize: "18px" }}>Enter a 6-digit pincode to load localities</div>
                ) : (
                  <select
                    name="locality"
                    value={formData.user.contactDetails.address.locality}
                    onChange={handleChange}
                    className={styles.loacalityInput}
                    required
                  >
                    <option value="">Select a locality</option>
                    {localityData.map((loc, index) => (
                      <option key={index} value={loc}>
                        {loc}
                      </option>
                    ))}
                  </select>
                )}
              </div>
              <div>
                <label htmlFor="city" className={styles.formLbel}>
                  City <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <input
                  className={styles.pincodeInput}
                  type="text"
                  name="city"
                  value={formData.user.contactDetails.address.city || ""}
                  placeholder="Auto-filled from pincode"
                  readOnly
                />
                {errors.cityerr && <div style={{ color: "red" }}>{errors.cityerr}</div>}
              </div>
              <div>
                <label htmlFor="state" className={styles.formLbel}>
                  State <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <input
                  className={styles.pincodeInput}
                  type="text"
                  name="state"
                  value={formData.user.contactDetails.address.state || ""}
                  placeholder="Auto-filled from pincode"
                  readOnly
                />
                {errors.stateerr && <div style={{ color: "red" }}>{errors.stateerr}</div>}
              </div>
            </>
          ) : (
            <>
              <div>
                <label className={styles.formLbel}>
                  Country <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <select
                  name="country"
                  className={styles.loacalityInput}
                  value={formData.user.contactDetails.address.country || ""}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select country</option>
                  {countrySelectOptions.map((c) => (
                    <option key={c} value={c}>
                      {c}
                    </option>
                  ))}
                </select>
                {errors.countryerr && <div style={{ color: "red" }}>{errors.countryerr}</div>}
              </div>
              <div>
                <label htmlFor="address" className={styles.formLbel}>
                  Full address <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <textarea
                  className={styles.pincodeInput}
                  name="addressLine1"
                  rows={3}
                  required
                  onChange={handleChange}
                  value={formData.user.contactDetails.address.addressLine1}
                  placeholder="Street, area, postal code if any (no Indian pincode required)"
                />
                {errors.addressError && (
                  <div style={{ color: "red", marginTop: "5px" }}>{errors.addressError}</div>
                )}
              </div>
            </>
          )}
          {/* image upload */}
          <div>
            <label className={styles.formLbel}>
              Profile Photo Upload <span style={{ color: "red" }}>*</span>{" "}
              <i className={styles.documentsName}>
                (png,jpeg,gif are allowed with file size of 2mb)
              </i>
            </label>
            <div className={styles.imageUpload}>
              <input type="file" name="image" onChange={handleImage} required />
              {/* <button type="button" onClick={imageUpload}>
                + Upload your Image
              </button> */}
            </div>
          </div>
          {/* gender */}
          <div>
            <label htmlFor="gender" className={styles.formLbel}>
              Enter Your Gender <span style={{ color: "red" }}>*</span>
            </label>
            <br />
            <label id={styles.radioLabels}>
              <input
                type="radio"
                id="gender"
                name="gender"
                value="male"
                checked={formData.user.gender === "male"}
                onChange={handleChange}
                required
              />
              Male
            </label>
            <label id={styles.radioLabels}>
              <input
                type="radio"
                id="gender"
                name="gender"
                value="female"
                checked={formData.user.gender === "female"}
                onChange={handleChange}
                required
              />
              Female
            </label>
          </div>
          {/* languages */}
          <div>
            <label htmlFor="languages" className={styles.formLbel}>
              Add Languages That You Speak{" "}
              <span style={{ color: "red" }}>*</span>
            </label>
            <div className={styles.languages}>
              <div>
                {/* Language Dropdown */}
                <select
                  onChange={handleSelectLanguage}
                  className={styles.langSelect}
                  value={selectedLanguage}
                >
                  <option value="" disabled>
                    Select Language
                  </option>
                  {uniqueLanguages.map((language) => (
                    <option key={language} value={language}>
                      {language}
                    </option>
                  ))}
                </select>

                {/* Proficiency Dropdown */}
                <select
                  onChange={handleSelectProficiency}
                  className={styles.langSelect}
                  value={selectedProficiency}
                  disabled={!selectedLanguage}
                >
                  <option value="" disabled>
                    Select Proficiency
                  </option>
                  {proficiencyOptions.map((proficiency) => (
                    <option key={proficiency} value={proficiency}>
                      {proficiency}
                    </option>
                  ))}
                </select>

                <button
                  onClick={handleAddLanguage}
                  className={styles.addLangButton}
                  disabled={!selectedLanguage || !selectedProficiency}
                >
                  Add Language
                </button>
              </div>
            </div>

            {/* Display the selected languages */}
            <div className={styles.selectedLang}>
              {selectedLanguageList.map((lang) => (
                <div key={lang.language}>
                  <span>
                    {" "}
                    <TiTick
                      style={{ color: " #7f60f9", verticalAlign: "middle" }}
                    />{" "}
                    {lang.language} - {lang.proficiency}
                  </span>
                  <button
                    onClick={() => handleRemoveLanguage(lang.language)}
                    className={styles.removeLangBtn}
                  >
                    Remove
                  </button>
                </div>
              ))}
            </div>
          </div>
          {/* Temporary: Yes/No shown; No always selected and non-editable */}
          <div>
            <label
              htmlFor="individualNo"
              ref={InstituteTutorRef}
              className={styles.formLbel}
            >
              Are You Associated With Institution{" "}
              <span style={{ color: "red" }}>*</span>
            </label>
            <br />
            <label id={styles.radioLabels}>
              <input
                type="radio"
                id="individualNo"
                name="individual"
                value="true"
                checked
                disabled
                readOnly
              />
              No
            </label>
            <label id={styles.radioLabels}>
              <input
                type="radio"
                id="individualYes"
                name="individual"
                value="false"
                checked={false}
                disabled
                readOnly
              />
              Yes
            </label>
          </div>

          {/*degree input  */}
          <div>
            <label className={styles.formLbel}>
              Add Your degree <span style={{ color: "red" }}>*</span>{" "}
            </label>
            <br />
            <div className={styles.degreeInput}>
              <div className={styles.degreeField}>
                <label htmlFor="educationalBackground" className={styles.formLbel}>
                  Degree <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  id="educationalBackground"
                  onChange={handleChange}
                  name="educationalBackground"
                  value={formData.educationalBackground}
                  required
                >
                  <option value="" disabled style={{ display: "none" }}>
                    Select Degree
                  </option>
                  <option value="Bachelor's">Bachelor's</option>
                  <option value="Master's">Master's</option>
                </select>
              </div>
              <div className={styles.degreeField}>
                <label htmlFor="degreeStatus" className={styles.formLbel}>
                  Degree Status <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  id="degreeStatus"
                  onChange={handleChange}
                  name="degreeStatus"
                  value={formData.degreeStatus}
                  required
                >
                  <option value="" disabled style={{ display: "none" }}>
                    Completed/Pursuing
                  </option>
                  <option value="COMPLETED">Completed</option>
                  <option value="PURSUING">Pursuing</option>
                </select>
              </div>
              <div className={styles.degreeField}>
                <label htmlFor={styles.completeyear} className={styles.formLbel}>
                  Year of Passing <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="date"
                  id={styles.completeyear}
                  name="yearofcompletion"
                  placeholder="Year of Passing"
                  onChange={handleChange}
                  value={formData.yearofcompletion}
                  required
                  max={formData.degreeStatus === "COMPLETED" ? today : ""}
                />
              </div>
            </div>
          </div>
          {/* exp in years */}
          <div className={styles.experience}>
            <label htmlFor="yearOfExp" className={styles.formLbel}>
              Years of Experience <span style={{ color: "red" }}>*</span>
            </label>
            <br />
            <input
              type="number"
              placeholder="Enter a Experience"
              onChange={handleChange}
              value={formData.yearOfExp}
              id="yearOfExp"
              name="yearOfExp"
              min="1"
              max="98"
              required
            />
            {yearOfExperrors && (
              <div style={{ color: "red" }}>{yearOfExperrors}</div>
            )}
          </div>
          <TutorTeachingPreferences
            subjectData={subjectData}
            selectedBoards={selectedBoards}
            selectedGrades={selectedGrades}
            selectedCategoryIds={selectedCategoryIds}
            studyGroupTypes={studyGroupTypes}
            onBoardsChange={setSelectedBoards}
            onGradesChange={setSelectedGrades}
            onCategoryIdsChange={setSelectedCategoryIds}
            onStudyGroupTypesChange={setStudyGroupTypes}
            onSubjectCatalogUpdated={handleSubjectCatalogUpdated}
            allowAddMissingSubject
            addedByUserId={userId || ""}
            addedByTutorId={tutorId || ""}
            addedByName={addedByName}
            errors={teachingErrors}
          />
          {/* fee per month */}
          <div>
            <label htmlFor="feePerHour" className={styles.formLbel}>
              How Much Do You Charge Per Month?{" "}
              <span style={{ color: "red" }}>*</span>
            </label>
            <br />
            <input
              type="number"
              value={formData.feePerHour}
              name="feePerHour"
              onChange={handleChange}
              required
              placeholder="₹  2000/-"
              className={styles.chargesInput}
            />
            {/* {feeError && <span style={{ color: "red" }}>{feeError}</span>} */}
            {feeError && <div style={{ color: "red" }}>{feeError}</div>}
          </div>

          <div>
            <label htmlFor="accountHolderName" className={styles.formLbel}>
              Account Holder Name <span style={{ color: "red" }}>*</span>
            </label>
            <br />
            <input
              type="text"
              value={formData.accountHolderName}
              name="accountHolderName"
              onChange={handleChange}
              required
              placeholder="Name as per bank / UPI"
              className={styles.chargesInput}
            />
            {errors.accountHolderName && (
              <div style={{ color: "red" }}>{errors.accountHolderName}</div>
            )}
          </div>

          <div>
            <label htmlFor="upiId" className={styles.formLbel}>
              UPI ID <span style={{ color: "red" }}>*</span>
            </label>
            <br />
            <input
              type="text"
              value={formData.upiId}
              name="upiId"
              onChange={handleChange}
              required
              placeholder="example@oksbi"
              className={styles.chargesInput}
            />
            {errors.upiId && <div style={{ color: "red" }}>{errors.upiId}</div>}
          </div>

          {/* timeslots */}

          <div>
            <label htmlFor="availability" className={styles.formLbel}>
              Days And Time Slot When You Are Available To Teach?
            </label>
            <TutorAvailabilityQuickApply
              timeSlots={timeSlots}
              onApply={handleQuickApplyAvailability}
            />
            <div className={styles.timeSlots}>
              {daySelections.map((selection) => (
                <div key={selection.id} className={styles.timeslotscontainer}>
                  <select
                    value={selection.day}
                    onChange={(e) => handleDayChange(e, selection.id)}
                    required
                  >
                    <option value="">Select Day</option>
                    <option value="MONDAY">Monday</option>
                    <option value="TUESDAY">Tuesday</option>
                    <option value="WEDNESDAY">Wednesday</option>
                    <option value="THURSDAY">Thursday</option>
                    <option value="FRIDAY">Friday</option>
                    <option value="SATURDAY">Saturday</option>
                    <option value="SUNDAY">Sunday</option>
                  </select>
                  <select
                    value={selection.timeSlot}
                    onChange={(e) => handleTimeSlotChange(e, selection.id)}
                    disabled={!selection.day}
                    required
                  >
                    <option value="">Select Time Slot</option>
                    {timeSlots
                      .filter((slot) => slot.daysOfWeek === selection.day)
                      .map((slot) => (
                        <option key={slot.timeSlotId} value={slot.timeSlotId}>
                          {slot.startTime} - {slot.endTime}
                        </option>
                      ))}
                  </select>
                  {daySelections.length > 1 && (
                    <button
                      type="button"
                      onClick={() => handleRemove(selection.id)}
                      className={styles.removeButton}
                    >
                      Remove
                    </button>
                  )}
                </div>
              ))}
              <div className={styles.timeSlotActions}>
                <button type="button" onClick={handleAddMore}>
                  + Add More
                </button>
                <button
                  type="button"
                  onClick={handleClearAllTimeSlots}
                  className={styles.clearTimeSlotsButton}
                  disabled={
                    daySelections.length === 1 &&
                    !daySelections[0].day &&
                    !daySelections[0].timeSlot
                  }
                >
                  Clear all
                </button>
              </div>
            </div>
          </div>

          {/* description of experience */}
          <div>
            <label htmlFor="experience" className={styles.formLbel}>
              Experience In
              <span style={{ color: "red" }}>*</span>
            </label>
            <br />
            <textarea
              name="experience"
              value={formData.experience}
              onChange={handleChange}
              placeholder="Type your text here..."
              className={styles.textarea}
              rows="4"
              minLength={20}
              maxLength={120}
            />
            {/* {errors && <p style={{ color: "red" }}>{errors}</p>}  */}
          </div>
          {/* documents upload */}
          <div className={styles.documents}>
            <label htmlFor="documents" className={styles.formLbel}>
              Upload Documents
              <span style={{ color: "red" }}>*</span>
              <i className={styles.documentsName}>
                (Photo ID Card and Educational Certificates are mandatory; others optional)
              </i>
            </label>
            <br />
            {inputFields.map((field) => (
              <div className={styles.documentcontainer} key={field.id}>
                <input
                  type="file"
                  // multiple
                  onChange={(e) => handleFileChange(e, field.id)}
                  accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
                />
                <select
                  value={field.docType}
                  onChange={(e) => handleDocTypeChange(e, field.id)}
                  className={styles.docTypeSelect}
                  required
                >
                  <option value="" disabled>
                    Select Document Type
                  </option>
                  {DOCUMENT_TYPES.map((doc) => (
                    <option key={doc.value} value={doc.value}>
                      {doc.label}
                    </option>
                  ))}
                </select>
                {inputFields.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removeFileInput(field.id)}
                    className={styles.removeDocButton}
                  >
                    -
                  </button>
                )}
              </div>
            ))}
            {/* <button
              className={styles.documentBtn}
              type="button"
              onClick={documentUpload}
            >
              Upload Your Documents
            </button> */}
            <button
              className={styles.documentsAddMore}
              type="button"
              onClick={addFileInput}
            >
              + Add Files
            </button>
            <i className={styles.documentsName}>
              (pdf, word, docx, png, jpg, jpeg are allowed with file size of 10mb each file)
            </i>
          </div>

          {/* terms check */}
          <div id={styles.terms}>
            <input
              type="checkbox"
              id="termsCheckbox"
              name="termsCheckbox"
              checked={formData.infoCorrect}
              onChange={handleChange}
            />
            <label htmlFor="termsCheckbox">
              I confirm that the information I have provided is correct and agree
              to the <TermsLink label="Terms of Use & Privacy Policy" />.
            </label>
          </div>
          {/* <div className={styles.submitBtns}>
            <button className={styles.submitBtn} type="submit">
              Create Profile
            </button>
            <button onClick={handleCancel} className={styles.submitBtn}>
              Cancel
            </button>
          </div> */}
          <div className={styles.buttonsSection}>
            <div className={styles.buttonWrapper}>
              <button disabled={true} style={{ cursor: "not-allowed" }}>
                Save
              </button>
              {visibleSections.save && (
                <div className={styles.content}>
                  <span>
                    Save your data and documents. You can still edit them later.
                    Ops Manager won't be notified.
                  </span>
                  <span
                    className={styles.closeBtn}
                    onClick={() => handleToggleVisibility("save")}
                  >
                    x
                  </span>
                </div>
              )}
            </div>

            <div className={styles.buttonWrapper}>
              <button
                type="submit"
                disabled={isSubmitting}
                style={{ backgroundColor: "#00AB06" }}
              >
                Submit
              </button>
              {visibleSections.submit && (
                <div className={styles.content}>
                  <span>
                    Submit to finalize profile; documents will lock for
                    verification. Only new qualifications can be added later.
                  </span>
                  <span
                    className={styles.closeBtn}
                    onClick={() => handleToggleVisibility("submit")}
                  >
                    x
                  </span>
                </div>
              )}
            </div>

            <div className={styles.buttonWrapper}>
              <button
                onClick={handleCancel}
                style={{ backgroundColor: "#F96060" }}
              >
                Cancel
              </button>
              {visibleSections.cancel && (
                <div className={styles.content}>
                  <span>
                    Cancel to discard all changes. No information will be saved.
                  </span>
                  <span
                    className={styles.closeBtn}
                    onClick={() => handleToggleVisibility("cancel")}
                  >
                    x
                  </span>
                </div>
              )}
            </div>
          </div>
        </form>
      </div>
    </Applayout>
  );
};

export default Createprofiletutor;
